/**
 * Kill-switch for the enhanced affiliate card renderer.
 *
 * Blog posts default to the enhanced card block (with structural fallback to
 * the legacy bulleted HTML when coverage is insufficient — see
 * components/ui/blog-content-with-toc.tsx). If a specific slug ever ships a
 * regression that can't be auto-detected by the coverage guards, add it here
 * to force that slug back to the legacy display until it's fixed.
 *
 * Keep this list empty in normal operation.
 */

export const AFFILIATE_CARD_DISABLED_SLUGS: ReadonlySet<string> = new Set<string>([])

export function isAffiliateCardDisabled(slug: string | undefined | null): boolean {
  if (!slug) return false
  return AFFILIATE_CARD_DISABLED_SLUGS.has(slug)
}
